var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioMock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_683_5219)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#FEDD67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4478 6.43706C11.6919 6.19298 11.6919 5.79725 11.4478 5.55318C11.2037 5.3091 10.808 5.3091 10.5639 5.55318L7.00586 9.11123L5.4478 7.55318C5.20372 7.3091 4.808 7.3091 4.56392 7.55318C4.31984 7.79725 4.31984 8.19298 4.56392 8.43706L6.56392 10.4371C6.68113 10.5543 6.8401 10.6201 7.00586 10.6201C7.17162 10.6201 7.33059 10.5543 7.4478 10.4371L11.4478 6.43706Z",
    fill: "#061A2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_683_5219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioMock);
export default __webpack_public_path__ + "static/media/radioMock.68edefbb8d7e6e68c6ba914b45f99cfa.svg";
export { ForwardRef as ReactComponent };